import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../../../api/config';

// const url = `${PREFIX_URL}/v01/inbox/getByDocId`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/attachments/:fileId/activities`;

type GetFileActivityLogsResponse = {
  data: any;
  status: boolean;
};

export const getFileActivityLogs = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
}): Promise<GetFileActivityLogsResponse> => {
  return axios.get(
    generateRoutePath(url, {
      projectId: projectId,
      inboxEntryId: inboxEntryId,
      emailId: emailId,
      fileId: fileId,
    })
  );
};

export const emailFileActivityLogsKeys = {
  all: ['fileActivityLogs'] as const,
  detail: ({
    projectId,
    fileId,
    emailId,
    inboxEntryId,
  }: {
    projectId: string;
    fileId: number;
    emailId: number;
    inboxEntryId: number;
  }) =>
    [
      INBOX_API_KEY,
      ...emailFileActivityLogsKeys.all,
      projectId,
      fileId,
      { emailId, inboxEntryId },
    ] as const,
};

type QueryFnType = typeof getFileActivityLogs;

type useEmailFileActivityLogsOptions = {
  projectId: string;
  fileId: number;
  inboxEntryId: number;
  emailId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useEmailFileActivityLogs = ({
  projectId,
  fileId,
  config,
  ...otherParams
}: useEmailFileActivityLogsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...emailFileActivityLogsKeys.all, projectId, fileId, otherParams],
    queryFn: () => getFileActivityLogs({ projectId, fileId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
